<template>
  <PriorityPlusWrapper class="py-2" :items="navigationItems">
    <template #item="{ item }">
      <CvdNavigationMenu v-if="item.children" :navigation-item="item">
        {{ t(item.labelKey) }}
      </CvdNavigationMenu>
      <CvdNavigationRouterLink
        v-else
        active-class="bg-primary text-neutral pointer-events-none cursor-default"
        :to="{ name: 'cvdPage', params: { slug: [item.slug] } }"
        @click="handleNavigationLinkClick(item)">
        {{ t(item.labelKey) }}
      </CvdNavigationRouterLink>
    </template>
    <template #plusItems="{ invisibleItems, closeMenu }">
      <CvdNestedNavigationList
        :navigation-items="invisibleItems"
        @selected="closeMenu" />
    </template>
  </PriorityPlusWrapper>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";

import CvdNavigationMenu from "@/components/Cvd/CvdNavigation/CvdNavigationMenu.vue";
import CvdNavigationRouterLink from "@/components/Cvd/CvdNavigation/CvdNavigationRouterLink.vue";
import CvdNestedNavigationList from "@/components/Cvd/CvdNavigation/CvdNestedNavigationList.vue";
import PriorityPlusWrapper from "@/components/Cvd/PriorityPlus/PriorityPlusWrapper.vue";
import { useTracking } from "@/composition/shared/useTracking.ts";
import useCvdStore from "@/stores/cvd.ts";
import type { TopLevelNavigationItem } from "@/types/Cvd.ts";

const cvdStore = useCvdStore();
const { t } = useI18n();
const { navigationItems } = storeToRefs(cvdStore);

const { trackEvent } = useTracking();
function handleNavigationLinkClick(item: TopLevelNavigationItem) {
  trackEvent("categoryNavigation_click_textButton_navlink", item.slug);
}
</script>
